// src/ui/styles/intro.css.js
//
// Soft Midnight Glass — Intro Overlay Styles
// ------------------------------------------
// Provides a premium intro animation overlay with:
//   - fullscreen fade-in / fade-out
//   - centered SVG animation
//   - soft glass backdrop
//   - smooth transitions

import {css} from 'lit';

export const introStyles = css`
  :host {
    display: block;
  }

  /* ------------------------------------------------------------
     Fullscreen overlay
  ------------------------------------------------------------ */
  .intro {
    position: fixed;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: rgba(10, 10, 15, 0.75);
    backdrop-filter: blur(18px) saturate(140%);

    opacity: 0;
    pointer-events: none;

    transition: opacity var(--transition-slow);
    z-index: 2000;
  }

  .intro.visible {
    opacity: 1;
    pointer-events: auto;
  }

  /* ------------------------------------------------------------
     Centered animation container
  ------------------------------------------------------------ */
  .anim-container {
    width: 180px;
    height: 180px;

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    transform: scale(0.9);

    transition:
      opacity var(--transition-slow),
      transform var(--transition-slow);
  }

  .intro.visible .anim-container {
    opacity: 1;
    transform: scale(1);
  }

  /* ------------------------------------------------------------
     SVG animation
  ------------------------------------------------------------ */
  svg {
    width: 100%;
    height: 100%;
    stroke: var(--accent);
    fill: none;
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round;

    animation: draw 2.4s ease forwards;
  }

  @keyframes draw {
    0% {
      stroke-dasharray: 0 400;
      opacity: 0.2;
    }
    40% {
      opacity: 1;
    }
    100% {
      stroke-dasharray: 400 0;
      opacity: 1;
    }
  }
`;